/* eslint no-inline-comments: 0 */

import { network_children } from '../network_rules/_routes.js';
import { org_children } from '../org_rules/_routes.js';

const Parent = () => import( /* webpackChunkName: "group-network-rules" */ `./classification-rules.vue` );

// Classification rules: one page, one tab per kind of rule.
//   Network rules  /classification-rules/network/...   ../network_rules/
//   Org rules      /classification-rules/org/...       ../org_rules/
export default {
	path: `classification-rules`,
	component: Parent,
	children: [
		{
			path: ``,
			name: `classification-rules`,
			redirect: {
				name: `classification-rules-network`
			}
		},
		...network_children,
		...org_children
	]
};
